"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    ", ";\n    border: ", ";\n    border-radius: ", ";\n\n    &:hover {\n        border: ", ";\n    }\n\n    &:disabled {\n        border-color: ", ";\n    }\n\n    &:focus {\n        border: ", ";\n\n        & + input {\n            border: ", ";\n\n            & + button {\n                border: ", ";\n            }\n\n            &:hover {\n                border: ", ";\n            }\n"], ["\n    display: flex;\n    ", ";\n    border: ", ";\n    border-radius: ", ";\n\n    &:hover {\n        border: ", ";\n    }\n\n    &:disabled {\n        border-color: ", ";\n    }\n\n    &:focus {\n        border: ", ";\n\n        & + input {\n            border: ", ";\n\n            & + button {\n                border: ", ";\n            }\n\n            &:hover {\n                border: ", ";\n            }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  border-left: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n"], ["\n  border-left: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  border-right: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n"], ["\n  border-right: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: 40px;\n  box-sizing: border-box;\n  background: ", ";\n  text-align: ", ";\n  ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  outline: none;\n  border: 0;\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    ", ";\n    margin: 0;\n  }\n\n  [type=\"number\"] {\n    ", ";\n  }\n\n  & + button {\n    border: 0;\n  }\n\n  &::placeholder {\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n  }\n"], ["\n  width: ", ";\n  height: 40px;\n  box-sizing: border-box;\n  background: ", ";\n  text-align: ", ";\n  ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  outline: none;\n  border: 0;\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    ", ";\n    margin: 0;\n  }\n\n  [type=\"number\"] {\n    ", ";\n  }\n\n  & + button {\n    border: 0;\n  }\n\n  &::placeholder {\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n  }\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  outline: none;\n  border: 0;\n  background: ", ";\n  padding: 0 ", "px;\n  cursor: pointer;\n\n  & > svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  &:disabled {\n    background: ", ";\n  }\n"], ["\n  outline: none;\n  border: 0;\n  background: ", ";\n  padding: 0 ", "px;\n  cursor: pointer;\n\n  & > svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  &:disabled {\n    background: ", ";\n  }\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 40px;\n  border: 0;\n  padding: ", ";\n  background: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 40px;\n  border: 0;\n  padding: ", ";\n  background: ", ";\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  background: transparent;\n  ", ";\n  ", ";\n\n  & > div:first-child > div {\n    text-align: center;\n  }\n\n  &:focus {\n    &:after {\n      content: \"\";\n      z-index: 1;\n      background: ", ";\n      bottom: 0;\n      ", ";\n      position: absolute;\n    }\n  }\n\n  g {\n    fill: ", ";\n  }\n\n  &:hover {\n    g {\n      fill: ", ";\n    }\n  }\n\n  & > div:nth-child(2) {\n    box-shadow: none;\n  }\n\n  min-width: 100px;\n"], ["\n  background: transparent;\n  ", ";\n  ", ";\n\n  & > div:first-child > div {\n    text-align: center;\n  }\n\n  &:focus {\n    &:after {\n      content: \"\";\n      z-index: 1;\n      background: ", ";\n      bottom: 0;\n      ", ";\n      position: absolute;\n    }\n  }\n\n  g {\n    fill: ", ";\n  }\n\n  &:hover {\n    g {\n      fill: ", ";\n    }\n  }\n\n  & > div:nth-child(2) {\n    box-shadow: none;\n  }\n\n  min-width: 100px;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getSize = require("../../helpers/getSize");

var _getSize2 = _interopRequireDefault(_getSize);

var _getColor = require("../../helpers/getColor");

var _getColor2 = _interopRequireDefault(_getColor);

var _inputFilter = require("../../helpers/inputFilter");

var _inputFilter2 = _interopRequireDefault(_inputFilter);

var _validateEmail = require("../../helpers/validateEmail");

var _validateEmail2 = _interopRequireDefault(_validateEmail);

var _colors = require("../../constants/colors");

var _radius = require("../../constants/radius");

var _sizes = require("../../constants/sizes");

var _text = require("../../constants/text");

var _opacity = require("../../constants/opacity");

var _opacity2 = _interopRequireDefault(_opacity);

var _inactive = require("../../atoms/icons/close/inactive");

var _inactive2 = _interopRequireDefault(_inactive);

var _label = require("../text/label");

var _label2 = _interopRequireDefault(_label);

var _dropDown = require("../../molecules/lists/dropDown");

var _dropDown2 = _interopRequireDefault(_dropDown);

var _errorLabel = require("../errorLabel");

var _container = require("../../layouts/container");

var _container2 = _interopRequireDefault(_container);

var _ = require("../..");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputComponentContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var disabled = _ref.disabled;
    return disabled && "pointer-events: none";
}, function (_ref2) {
    var hasError = _ref2.hasError;
    return hasError ? "1px solid " + _colors.Colors.Error : "1px solid " + _colors.Colors.StrokeDark;
}, _radius.Radius.small, function (_ref3) {
    var hasError = _ref3.hasError;
    return hasError ? "1px solid " + _colors.Colors.Error : "1px solid " + _colors.Colors.Primary;
}, _colors.Colors.StrokeDark, function (_ref4) {
    var hasError = _ref4.hasError;
    return hasError ? "1px solid " + _colors.Colors.Error : "1px solid " + _colors.Colors.Primary;
}, function (_ref5) {
    var hasError = _ref5.hasError;
    return hasError ? "1px solid " + _colors.Colors.Error : "1px solid " + _colors.Colors.Primary;
}, function (_ref6) {
    var hasError = _ref6.hasError;
    return hasError ? "1px solid " + _colors.Colors.Error : "1px solid " + _colors.Colors.Primary;
}, function (_ref7) {
    var hasError = _ref7.hasError;
    return hasError ? "1px solid " + _colors.Colors.Error : "1px solid " + _colors.Colors.Primary;
});

var InputLabel = (0, _styledComponents2.default)(_label2.default)(_templateObject2, (0, _getSize2.default)(_sizes.Sizes.xxs));

var borderLeftNone = (0, _styledComponents.css)(_templateObject3);

var borderRightNone = (0, _styledComponents.css)(_templateObject4);

var InputComponent = _styledComponents2.default.input(_templateObject5, function (_ref8) {
    var size = _ref8.size;
    return size && (0, _getSize2.default)(size) * 3 + "px" || "100%";
}, _colors.Colors.LightMode, function (_ref9) {
    var textAlign = _ref9.textAlign;
    return textAlign || "left";
}, function (_ref10) {
    var textAlign = _ref10.textAlign;
    return textAlign === "left" && "padding-left: " + (0, _getSize2.default)(_sizes.Sizes.sm) + "px;";
}, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightNormal, function (_ref11) {
    var secondaryStyle = _ref11.secondaryStyle;
    return secondaryStyle ? _text.TextSizes.P3FontSize : _text.TextSizes.P2FontSize;
}, function (_ref12) {
    var secondaryStyle = _ref12.secondaryStyle;
    return secondaryStyle ? _text.TextSizes.P3LineHeight : _text.TextSizes.P2LineHeight;
}, _text.TextSizes.ParagraphLetterSpacing, function (_ref13) {
    var disabled = _ref13.disabled,
        hasError = _ref13.hasError;

    if (disabled) return _colors.Colors.StrokeVeryDark;
    if (hasError) return _colors.Colors.Error;
    return _colors.Colors.PrimaryText;
}, function (_ref14) {
    var disableArrow = _ref14.disableArrow;
    return disableArrow ? "-webkit-appearance: none;" : "";
}, function (_ref15) {
    var disableArrow = _ref15.disableArrow;
    return disableArrow ? "-moz-appearance: textfield;" : "";
}, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightNormal, function (_ref16) {
    var secondaryStyle = _ref16.secondaryStyle;
    return secondaryStyle ? _text.TextSizes.P3FontSize : _text.TextSizes.P2FontSize;
}, function (_ref17) {
    var secondaryStyle = _ref17.secondaryStyle;
    return secondaryStyle ? _text.TextSizes.P3LineHeight : _text.TextSizes.P2LineHeight;
}, _text.TextSizes.ParagraphLetterSpacing, function (_ref18) {
    var disabled = _ref18.disabled,
        hasError = _ref18.hasError;

    if (disabled) return _colors.Colors.StrokeVeryDark;
    if (hasError) return (0, _getColor2.default)(_colors.Colors.Error, _opacity2.default.Light);
    return _colors.Colors.StrokeVeryDark;
}, _colors.Colors.LightMode);

var ClearButton = _styledComponents2.default.button(_templateObject6, function (_ref19) {
    var hasError = _ref19.hasError;
    return hasError ? (0, _getColor2.default)(_colors.Colors.Error, _opacity2.default.VeryLight) : _colors.Colors.LightMode;
}, (0, _getSize2.default)(_sizes.Sizes.xs), _colors.Colors.LightMode);

var InputInnerLabel = _styledComponents2.default.div(_templateObject7, function (_ref20) {
    var extraLabels = _ref20.extraLabels;
    return !extraLabels && "0 " + (0, _getSize2.default)(_sizes.Sizes.sm) + "px";
}, function (_ref21) {
    var disabled = _ref21.disabled;
    return disabled ? _colors.Colors.StrokeLight : _colors.Colors.StrokeVeryDark;
});

var InputDropDown = (0, _styledComponents2.default)(_dropDown2.default)(_templateObject8, function (_ref22) {
    var extraLabelAlign = _ref22.extraLabelAlign;
    return extraLabelAlign === "left" ? borderRightNone : borderLeftNone;
}, function (_ref23) {
    var disabled = _ref23.disabled;
    return !disabled && "border: 0 !important";
}, function (_ref24) {
    var disabled = _ref24.disabled;
    return disabled ? _colors.Colors.StrokeLight : _colors.Colors.StrokeVeryDark;
}, function (_ref25) {
    var extraLabelAlign = _ref25.extraLabelAlign;
    return extraLabelAlign === "left" ? "left: 0" : "right: 0";
}, _colors.Colors.LightMode, _colors.Colors.Secondary);

var Input = function (_React$Component) {
    _inherits(Input, _React$Component);

    function Input(props) {
        _classCallCheck(this, Input);

        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

        _this.toggleFocus = function () {
            _this.setState({ isFocusState: !_this.state.isFocusState });
        };

        _this.handleChange = function (e) {
            _this.validateInput(e.target.value);
            _this.props.changeEvent((0, _inputFilter2.default)(e.target.value, _this.props.value, _this.props.type));
        };

        _this.shouldRenderExtraLabel = function (dir) {
            if (_this.props.extraLabel || _this.props.extraLabels) {
                if (dir === "right" && _this.props.extraLabelAlign !== "left") return true; //direction is right by default
                return _this.props.extraLabelAlign === dir;
            }
        };

        _this.renderInnerLabel = function (type) {
            return _react2.default.createElement(
                InputInnerLabel,
                {
                    disabled: _this.props.disabled,
                    extraLabels: _this.props.extraLabels && type !== "symbol",
                    extraLabelAlign: type === "symbol" ? _this.props.symbolLabelAlign : _this.props.extraLabelAlign,
                    isFocusState: _this.state.isFocusState,
                    hasError: _this.props.error
                },
                type !== "symbol" && _this.props.extraLabels ? _react2.default.createElement(InputDropDown, {
                    references: _this.props.extraLabels,
                    changeEvent: _this.props.extraLabelChange,
                    placeholder: _this.props.extraLabelPlaceholder,
                    value: _this.props.extraLabelValue,
                    extraLabelAlign: _this.props.extraLabelAlign,
                    inverse: !_this.props.disabled,
                    disabled: _this.props.disabled,
                    hasError: _this.props.error
                }) : _react2.default.createElement(InputLabel, {
                    inverse: true,
                    text: type === "symbol" ? _this.props.symbolLabel : _this.props.extraLabel,
                    disabled: _this.props.disabled
                })
            );
        };

        _this.getLabel = function () {
            if (!_this.props.label) return null;

            var label = _react2.default.createElement(_label2.default, {
                color: _this.props.labelColor,
                text: _this.props.label,
                bottom: _sizes.Sizes.xxs,
                textAlign: _.Alignments.left,
                disabled: _this.props.disabled,
                error: _this.props.error,
                size: _sizes.Sizes.md
            });

            if (!_this.props.optional) return label;

            return _react2.default.createElement(
                _container2.default,
                { inline: true },
                label,
                _react2.default.createElement(_label2.default, {
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Input.optional" }),
                    bottom: _sizes.Sizes.xxs,
                    textAlign: _.Alignments.left,
                    color: _colors.Colors.StrokeVeryDark,
                    size: _sizes.Sizes.sm,
                    italic: true
                })
            );
        };

        _this.validateInput = function (value) {
            if (!String(value) || !_this.props.type) {
                _this.setState({ error: false });
                return;
            }

            switch (_this.props.type.toUpperCase()) {
                case "EMAIL":
                    value && _this.props.sectionUIValidation && _this.props.sectionUIValidation(_defineProperty({}, _this.props.position, (0, _validateEmail2.default)(value) ? (0, _validateEmail2.default)(value) : true));
                    _this.setState({ error: !(0, _validateEmail2.default)(value) });
                    break;
                default:
                    _this.setState({ error: false });
                    break;
            }
        };

        _this.handleClear = function () {
            if (_this.props.onClear) {
                _this.props.onClear();
                _this.setState({ isPrefilled: false });
            } else {
                _this.props.changeEvent("", _this.props.value, _this.props.type);
            }

            if (_this.inputRef.current) _this.inputRef.current.value = "";
        };

        _this.shouldShowClearButton = function () {
            return Boolean(!_this.props.hideClearBtn && _this.state.isPrefilled && _this.props.value || _this.props.hideClearBtn && _this.props.isCheckDOMValue && _this.inputRef.current && _this.inputRef.current.value);
        };

        _this.inputRef = _react2.default.createRef();
        _this.state = {
            isFocusState: false,
            error: false,
            isPrefilled: false
        };
        return _this;
    }

    _createClass(Input, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.symbolLabel && (this.props.extraLabel || this.props.extraLabels) && this.props.symbolLabelAlign === this.props.extraLabelAlign) {
                console.error("Input component: symbol label and extra label cannot have the same alignment");
            }
            if (this.props.value) {
                this.setState({ isPrefilled: true });
                this.validateInput(this.props.value);
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (this.props.value !== prevProps.value) {
                this.setState({ isPrefilled: !!this.props.value });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _container2.default,
                {
                    top: this.props.top,
                    bottom: this.props.bottom,
                    left: this.props.left,
                    right: this.props.right,
                    fullWidth: this.props.fullWidth
                },
                this.getLabel(),
                _react2.default.createElement(
                    InputComponentContainer,
                    { disabled: this.props.disabled, hasError: this.props.error || this.state.error },
                    this.props.symbolLabel && this.props.symbolLabelAlign === "left" && this.renderInnerLabel("symbol"),
                    this.shouldRenderExtraLabel("left") && this.renderInnerLabel(),
                    _react2.default.createElement(InputComponent, {
                        autoComplete: "off",
                        onFocus: this.toggleFocus,
                        onBlur: this.props.onBlur || this.toggleFocus,
                        textAlign: this.props.textAlign || "left",
                        size: this.props.size,
                        value: this.props.value,
                        onChange: this.handleChange,
                        onKeyPress: this.props.onKeyPress,
                        placeholder: this.props.placeholder,
                        maxLength: this.props.maxLength,
                        hasExtraLabel: this.props.extraLabel || this.props.extraLabels,
                        extraLabelAlign: this.props.extraLabelAlign,
                        symbolLabel: this.props.symbolLabel,
                        symbolLabelAlign: this.props.symbolLabelAlign,
                        disabled: this.props.disabled,
                        hasError: this.props.error || this.state.error,
                        isPrefilled: this.state.isPrefilled,
                        type: this.props.type || "text",
                        inverse: this.props.inverse,
                        id: (this.props.id || "") + "Input",
                        ref: this.inputRef,
                        className: this.props.className,
                        secondaryStyle: this.props.secondaryStyle,
                        disableArrow: this.props.disableArrow
                    }),
                    this.shouldShowClearButton() && _react2.default.createElement(
                        ClearButton,
                        {
                            hasError: this.props.error || this.state.error,
                            disabled: this.props.disabled,
                            onClick: this.handleClear,
                            hasExtraLabel: this.props.extraLabel || this.props.extraLabels,
                            extraLabelAlign: this.props.extraLabelAlign,
                            inverse: this.props.inverse
                        },
                        _react2.default.createElement(_inactive2.default, null)
                    ),
                    this.shouldRenderExtraLabel("right") && this.renderInnerLabel(),
                    this.props.symbolLabel && this.props.symbolLabelAlign !== "left" && this.renderInnerLabel("symbol")
                ),
                (this.props.error || this.state.error) && this.props.errorLabel && _react2.default.createElement(_errorLabel.ErrorLabel, { text: this.props.errorLabel, disabled: this.props.disabled }),
                this.props.serverErrors && this.props.serverErrors.length !== 0 && this.props.serverErrors.map(function (err) {
                    return _react2.default.createElement(_errorLabel.ErrorLabel, { error: true, listItem: true, textAlign: "left", text: err.message, disabled: _this2.props.disabled });
                }),
                this.props.serverWarnings && this.props.serverWarnings.length !== 0 && this.props.serverWarnings.map(function (war) {
                    return _react2.default.createElement(_errorLabel.ErrorLabel, { warning: true, listItem: true, textAlign: "left", text: war.message, disabled: _this2.props.disabled });
                })
            );
        }
    }]);

    return Input;
}(_react2.default.Component);

exports.default = Input;